<div class="bread-crumbs">
  @for (c of crumbs; track c; let isFirst = $first; let isLast = $last) {
    @if (isFirst) {
      <mat-icon svgIcon="arrow-small-left"></mat-icon>
    }
    @if (c.url != null) {
      <span
        [routerLink]="[c.url]"
        [queryParams]="c.query"
        routerLinkActive="router-link-active"
        class="link"
        >{{ c.name }} {{ !isLast ? "/" : "" }}</span
        >
      }
      @if (c.url == null) {
        <span routerLinkActive="router-link-active"
          >{{ c.name }} {{ !isLast ? "/" : "" }}</span
          >
        }
      }
    </div>
